<template>
    <div v-if="showAll" style="display: contents;">
        <div
             class="app-filter-btn">
            <reset-filter v-if="$store.state.selected_filters_count > 0 && showMenu" class="filters-mobile-results-clear-btn">
                hreinsa síu
            </reset-filter>
            <scroll-to-res-btn v-if="showResBtn"  />


            <a href="javascript:void(0);" @click.prevent="showMenuBtn" v-if="isActive"
               :class="['filters-mobile-filters-btn',  { active: isActive, 'is-app':!!$store.state.isApp }  ]">
                <span>{{ selectedFilterCount }} skilyrði</span>
                <svg viewBox="0 0 21 25" width="21px" height="25px">
                    <g fill="none" fill-rule="evenodd" stroke="#FFF" stroke-linecap="round"
                       stroke-linejoin="round" transform="rotate(90 9.5 10.5)">
                        <path d="M9 2.5h14M0 2.5h4M18 9.5h5M0 9.5h13M10 16.5h13M0 16.5h5"/>
                        <circle cx="6.5" cy="2.5" r="2.5"/>
                        <circle cx="15.5" cy="9.5" r="2.5"/>
                        <circle cx="7.5" cy="16.5" r="2.5"/>
                    </g>
                </svg>
            </a>
        </div>

    </div>
</template>


<script>
    import ResetFilter from "../ResetFilter.vue";
    import ScrollToResBtn from "@/components/Dealers/ScrollToResBtn.vue";
    import scroll from "../../helpers/scroll";
    import {mapGetters, mapMutations} from "vuex";


    export default {
        components: {
            ResetFilter,
            ScrollToResBtn
        },
        computed: {
          ...mapGetters(["showMenu"]),
          selectedFilterCount(){
            return this.$store.state.selected_filters_count;
          },
            showAll() {
              const carsPage = ['k7Cars','OldCars','DealersCars'];
              if(carsPage.includes(this.$route.name)){
                return this.$device.mobile() && !this.$store.state.showMobilePopUpMenu;
              }
              return false;
            },
          showResBtn(){
              return (!this.showMenu && this.selectedFilterCount == 0) || this.showMenu
          },
            /*showBtn() {
                if (!(this.$store.state.scrollTop > 500) && this.isCarPage) {
                    return true;
                    // }
                }
                return false;
            },*/
            isCarPage() {
                const route = this.$route.name ? this.$route.name : this.$router.currentRoute.name;

                return ['CarsInStock', 'DealersCars', 'OldCars', 'k7Cars'].indexOf(route) >= 0;
            },
            isActive() {
              return !this.showMenu && this.selectedFilterCount > 0;
                //return this.$store.state.selected_filters_count && this.isCarPage && this.$store.state.scrollTop > 500;
            }
        },
        methods: {
          ...mapMutations(['setShowMenu']),
          showMenuBtn(){
            this.setShowMenu(!this.showMenu);
          },
            scrollToTop: function () {
                scroll.to(0);
            }
        }
    }
</script>